import React, { createContext, useContext } from 'react';
const RouteConfigContext = createContext([]);
export const RouteConfigProvider = ({ routes, children, }) => React.createElement(RouteConfigContext.Provider, { value: routes }, children);
export const useRouteConfig = () => useContext(RouteConfigContext);
